import React, { Component } from 'react';
// import Config from './Config';
// import FX from './functions/functions';

class LogOut extends Component {
  constructor(props) {
    super(props);
    console.log(localStorage);
    localStorage.removeItem('token');
    //this.props.root.state.forceUpdate();
  }
  componentDidMount(){
    this.props.root.forceUpdate();
  }
  render() {
      return (
        <div className="LogOut">
          <br/><br/><br/><br/>
          <div>LogOut</div>
          <button onClick={() => {  localStorage.removeItem('token'); this.props.root.forceUpdate(); }}>Log Out</button>
        </div>
      );
  }
}

export default LogOut;



// WEBPACK FOOTER //
// ./src/LogOut.js